export default function initNativeShare() {
  const shareBtn = document.getElementById("native-share");

  // Verificación de seguridad: si el botón no existe o el navegador no soporta 'share', no hacemos nada.
  if (!shareBtn || !navigator.share) {
    if (shareBtn) {
      shareBtn.style.display = "none"; // Ocultamos el botón si la API no está disponible
    }
    return;
  }

  shareBtn.addEventListener("click", async () => {
    try {
      await navigator.share({
        title: document.title, // Usa el título actual de la página
        url: window.location.href, // Usa la URL actual
      });
    } catch (error) {
      // El usuario canceló el diálogo de compartir, no es necesario hacer nada.
      console.log("Error al compartir o diálogo cancelado.", error);
    }
  });
}
